import { helper } from '@ember/component/helper';

const allowedFilters = [ 'truthy' ];

export default helper(function arrayConcatHelper(params, { filter }) {
  let result = [].concat(...params);
  if (filter && allowedFilters.includes(filter)) {
    result = result.filter(filter === 'truthy' ? i => i : () => true);
  }
  return result;
});
